module.exports = __webpack_public_path__ + "static/media/Pin_Job_Fuel.cbc15e9a.svg";